import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { BUSINESS } from "@/lib/business";
import { useBooking } from "./BookingDialog";

const LINKS = [
  ["/#unterlagen", "Unterlagen"],
  ["/#bewertungen", "Bewertungen"],
  ["/#kontakt", "Kontakt"],
];
const navCls = "transition-colors hover:text-plate";

export const Header = () => {
  const openBooking = useBooking();
  return (
    <header className="sticky top-0 z-40 bg-paper/95 backdrop-blur-md text-ink border-b border-ink/10 shadow-[0_8px_24px_-18px_rgba(15,31,56,0.45)]">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 py-2 sm:py-3 flex items-center justify-between gap-3 sm:gap-4">
        <Link to="/" className="flex items-center shrink-0" data-testid="header-logo-link">
          <img src="/logo.png" alt={BUSINESS.fullName} className="h-12 sm:h-16 md:h-24 w-auto" data-testid="header-logo" />
        </Link>
        <div className="hidden lg:flex gap-6 lb">
          <Link to="/preise" className={navCls} data-testid="nav-preise">Leistungen & Preise</Link>
          {LINKS.map(([href, label]) => (
            <a key={href} href={href} className={navCls} data-testid={`nav-${label.toLowerCase()}`}>{label}</a>
          ))}
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <Link to="/preise" className="lb text-[11px] sm:text-xs lg:hidden rounded-full border border-ink/30 px-3 py-2 transition-colors hover:border-plate hover:text-plate" data-testid="nav-preise-mobile">Preise</Link>
          <button type="button" onClick={openBooking} className="lb text-[11px] sm:text-xs inline-flex items-center gap-1.5 sm:gap-2 whitespace-nowrap rounded-full sm:rounded-none bg-plate text-white px-3.5 sm:px-4 py-2 sm:py-2.5 transition-colors hover:bg-plate-hover" data-testid="header-booking-btn">
            <CalendarDays size={14} /> Termin<span className="hidden sm:inline -ml-1">buchen</span>
          </button>
        </div>
      </nav>
    </header>
  );
};
